import {
  requestImmediateDataFlush,
  logCustomEvent,
  isInitialized,
} from "@braze/web-sdk";
import { IGeolocation } from "@origin-digital/event-dispatcher";

export const syncBrazeSdkUserGeolocation = (
  geolocation: IGeolocation
): Promise<boolean> => {
  return new Promise((resolve) => {
    // eslint-disable-next-line prefer-const
    let intervalId: any;
    const waitToLogEvent = () => {
      if (isInitialized()) {
        const isEventLogged = logCustomEvent(
          "web::trigger::geolocation::updated",
          geolocation
        );
        requestImmediateDataFlush();
        intervalId = clearInterval(intervalId);
        resolve(isEventLogged);
      }
    };
    intervalId = setInterval(waitToLogEvent, 2000);
    setTimeout(() => {
      if (intervalId) {
        clearInterval(intervalId);
        resolve(false);
      }
    }, 10000);
  });
};
